/* eslint-disable */
// Generated by scripts/scope-tours/generate.ts from data-tour-* markers in the
// frontend and the docs sections they cite. Do not edit by hand; run
// `pnpm scope-tours:generate`.

export type ScopeTourStepDefinition = {
    /** CSS selector of the spotlit control; null renders a centered explainer. */
    target: string | null;
    route?: string;
    title: string;
    body: string;
    interactive: boolean;
    advanceOnTargetClick: boolean;
    advanceOnTargetInput: boolean;
    via: string[];
    /**
     * Optional hops on the way to `target`: controls that lead to it on the
     * instances that show them. Spotlit, with their own title, while one is
     * on the page and the target is not.
     */
    detour?: { target: string; title: string }[];
    /** The page's "still working" surface; the step waits for it to go. */
    busy?: string;
    /** With busy: the step Try again returns to when the page marks the work failed. */
    retryStep?: number;
    /** On an editor's typed step: the facts its Check button tests the file against. */
    expect?: Record<string, string>;
    /** For a typed step: what the card offers to fill in with one click. */
    suggestion?: string;
    /**
     * How many leading lines of a block suggestion are already in the file:
     * shown faded, as where the rest goes, and never typed.
     */
    suggestionContextLines?: number;
};

export type ScopeTourDefinition = {
    scope: string;
    title: string;
    /** Frontend files whose markers produced the steps. */
    sources: string[];
    steps: ScopeTourStepDefinition[];
    /**
     * Other scopes this lesson teaches with the same controls
     * (data-tour-covers). The library shows the lesson once, under this
     * scope, and completing it completes every scope listed here.
     */
    covers?: string[];
    /** The scope whose lesson this entry is a copy of; the library shows that one. */
    coveredBy?: string;
};

export const SCOPE_TOURS: Record<string, ScopeTourDefinition> = {
    'view:Dashboard': {
        scope: 'view:Dashboard',
        title: 'Open and read a dashboard',
        sources: [
            'packages/frontend/src/features/dashboardFilters/DashboardFiltersBar.tsx',
            'packages/frontend/src/components/DashboardTiles/DashboardChartTile.tsx',
            'packages/frontend/src/features/dateZoom/components/DateZoom.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:Dashboard"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Dashboards',
                body: 'A dashboard is a single view that arranges related charts alongside explanatory text and video.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-dashboards"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Open All dashboards',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Open Jaffle Shop overview',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                ],
            },
            {
                target: '[data-tour-scope="view:Dashboard"][data-tour-look="1"]',
                title: 'Filters sit at the top',
                body: "Filters sit at the top of a dashboard and change the data in the tiles below. Click a filter to change its value, or click **Add filter** to add your own — the filters you add yourself are temporary, so nobody else's view changes.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:Dashboard"][data-tour-step="2"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Open the date zoom',
                body: 'Date zoom lets viewers change the date granularity of time-based charts on a [dashboard](https://docs.lightdash.com/explore/dashboards) without editing them.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                    '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                ],
            },
            {
                target: '[data-tour-anchor="zoom-option"][data-tour-value="Month"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Choose Month',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:Dashboard"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'See the result',
                body: 'Date zoom changes the granularity of time-based charts — Day, Week, Month, and so on — without editing them.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:Dashboard': {
        scope: 'manage:Dashboard',
        title: 'Create a dashboard',
        sources: [
            'packages/frontend/src/components/DashboardTiles/TileBase/index.tsx',
            'packages/frontend/src/components/common/Dashboard/DashboardHeader.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:Dashboard"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Dashboards',
                body: 'A dashboard is a single view that arranges related charts alongside explanatory text and video.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-dashboard"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Choose Dashboard',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="dashboard-name"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Name your dashboard',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                ],
                suggestion: 'Orders overview',
            },
            {
                target: '[data-tour-anchor="dashboard-create-next"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Click Next',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                    '[data-tour-anchor="dashboard-name"]',
                ],
            },
            {
                target: '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Choose the Shared space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                    '[data-tour-anchor="dashboard-name"]',
                    '[data-tour-anchor="dashboard-create-next"]',
                ],
            },
            {
                target: '[data-tour-anchor="dashboard-create-submit"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Click Create',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                    '[data-tour-anchor="dashboard-name"]',
                    '[data-tour-anchor="dashboard-create-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                ],
            },
            {
                target: '[data-tour-anchor="add-tile"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Click Add tile',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                    '[data-tour-anchor="dashboard-name"]',
                    '[data-tour-anchor="dashboard-create-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="dashboard-create-submit"]',
                ],
            },
            {
                target: '[data-tour-anchor="add-saved-chart"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Choose Saved chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                    '[data-tour-anchor="dashboard-name"]',
                    '[data-tour-anchor="dashboard-create-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="dashboard-create-submit"]',
                    '[data-tour-anchor="add-tile"]',
                ],
            },
            {
                target: '[data-tour-anchor="chart-picker"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Open the chart list',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                    '[data-tour-anchor="dashboard-name"]',
                    '[data-tour-anchor="dashboard-create-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="dashboard-create-submit"]',
                    '[data-tour-anchor="add-tile"]',
                    '[data-tour-anchor="add-saved-chart"]',
                ],
            },
            {
                target: '[data-tour-anchor="chart-option"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Choose Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                    '[data-tour-anchor="dashboard-name"]',
                    '[data-tour-anchor="dashboard-create-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="dashboard-create-submit"]',
                    '[data-tour-anchor="add-tile"]',
                    '[data-tour-anchor="add-saved-chart"]',
                    '[data-tour-anchor="chart-picker"]',
                ],
            },
            {
                target: '[data-tour-anchor="add-charts-submit"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Click Add',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                    '[data-tour-anchor="dashboard-name"]',
                    '[data-tour-anchor="dashboard-create-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="dashboard-create-submit"]',
                    '[data-tour-anchor="add-tile"]',
                    '[data-tour-anchor="add-saved-chart"]',
                    '[data-tour-anchor="chart-picker"]',
                    '[data-tour-anchor="chart-option"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Dashboard"][data-tour-look="1"]',
                title: 'Try resizing or moving the tile',
                body: 'Resize a chart by dragging its lower-right corner, and position it by dragging its center.',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="manage:Dashboard"][data-tour-step="2"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/edit',
                title: 'Click Save changes',
                body: "When you're happy with the layout, hit **Save**.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-dashboard"]',
                    '[data-tour-anchor="dashboard-name"]',
                    '[data-tour-anchor="dashboard-create-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="dashboard-create-submit"]',
                    '[data-tour-anchor="add-tile"]',
                    '[data-tour-anchor="add-saved-chart"]',
                    '[data-tour-anchor="chart-picker"]',
                    '[data-tour-anchor="chart-option"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="add-charts-submit"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Dashboard"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'See the result',
                body: 'You can see every saved dashboard in your project under **Browse → All dashboards**.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:CustomFields': {
        scope: 'manage:CustomFields',
        title: 'Add a custom SQL dimension',
        sources: [
            'packages/frontend/src/components/Explorer/CustomDimensionModal/CustomSqlDimensionModal.tsx',
            'packages/frontend/src/components/Explorer/ExploreTree/SelectedFieldsSection.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:CustomFields"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Custom dimensions',
                body: "Sometimes, a group or filter that you need hasn't been added to your project, so you can use a custom dimension to create a grouping or filter on-the-fly.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-anchor="edit-chart"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Edit the chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-anchor="add-custom-dimension"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Add a custom dimension',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:CustomFields"][data-tour-look="1"]',
                title: 'A custom SQL dimension reads straight from the warehouse',
                body: 'Custom SQL dimensions let you pull in new data directly from your database, which means they can sometimes be used to bypass access restrictions.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="custom-dimension-label"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Name the dimension',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="add-custom-dimension"]',
                ],
                suggestion: 'Order size',
            },
            {
                target: '[data-tour-anchor="custom-dimension-sql"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Write the SQL',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="add-custom-dimension"]',
                    '[data-tour-anchor="custom-dimension-label"]',
                ],
                suggestion:
                    "CASE WHEN ${orders.amount} < 100 THEN 'small' ELSE 'large' END",
            },
            {
                target: '[data-tour-scope="manage:CustomFields"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Create the dimension',
                body: '**Only users with admin or developer permissions can create custom SQL dimensions** — or, on Enterprise plans, any user assigned a [custom role](https://docs.lightdash.com/workspace-admin/custom-roles) that includes the **Manage Custom Fields** scope (Create and edit custom dimensions).',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="add-custom-dimension"]',
                    '[data-tour-anchor="custom-dimension-label"]',
                    '[data-tour-anchor="custom-dimension-sql"]',
                ],
            },
            {
                target: '[data-tour-anchor="run-query"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Run the query',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="manage:CustomFields"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'See the result',
                body: 'Then, your new dimension will be added to your results table automatically and will appear in the **custom dimensions** space in your sidebar.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:Explore': {
        scope: 'manage:Explore',
        title: 'Explore data',
        sources: [
            'packages/frontend/src/components/Explorer/ExplorePanel/index.tsx',
            'packages/frontend/src/components/Explorer/ResultsCard/ExplorerResults.tsx',
            'packages/frontend/src/components/RefreshButton.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:Explore"][data-tour-step="1"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Run your own query',
                body: "Open a Table and you're in the Explore view: pick the dimensions and metrics you want, sort the results, and Lightdash writes the SQL for you.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-chart"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose Chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="explore-table"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open a table',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]', '[data-tour-nav="new-chart"]'],
            },
            {
                target: '[data-tour-scope="manage:Explore"][data-tour-look="1"]',
                title: 'The fields you can query',
                body: '**Metrics and dimensions** available on the table you selected',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="explore-metric"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Select a metric',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-table"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-dimension"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Select a dimension',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-table"]',
                    '[data-tour-anchor="explore-metric"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Explore"][data-tour-step="2"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Run the query',
                body: 'Hit **Run query** in the top right.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-table"]',
                    '[data-tour-anchor="explore-metric"]',
                    '[data-tour-anchor="explore-dimension"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Explore"][data-tour-step="1"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'See the result',
                body: '**Results**, the raw data returned from your database',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:VirtualView': {
        scope: 'manage:VirtualView',
        title: 'Edit a virtual view',
        sources: [
            'packages/frontend/src/components/Explorer/ExplorePanel/index.tsx',
            'packages/frontend/src/features/virtualView/components/HeaderVirtualView.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:VirtualView"][data-tour-step="1"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Edit or delete a virtual view',
                body: "To edit a virtual view, you need to open it in the Explorer, then beside the name, there's a three-dot-menu where you can choose to **edit** or **delete** the virtual view.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-sql-runner"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose Query using SQL runner',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="sql-runner-editor"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Write your query',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                ],
                suggestion:
                    'SELECT status, COUNT(*) AS orders FROM jaffle.orders GROUP BY 1',
            },
            {
                target: '[data-tour-anchor="sql-runner-run"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Run the query',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-cta-menu"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open the save options',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-cta-virtual-view"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose Create virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-create-virtual-view"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click Create virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                ],
            },
            {
                target: '[data-tour-anchor="virtual-view-name"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Name the virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                ],
                suggestion: 'Orders by status',
            },
            {
                target: '[data-tour-anchor="virtual-view-create-submit"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Create the virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                ],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                ],
            },
            {
                target: '[data-tour-nav="new-chart"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose Chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-search"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Search for the table',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                ],
                suggestion: 'Orders by status',
            },
            {
                target: '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open the Virtual Views section',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-table"][data-tour-value="Orders by status"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open Orders by status',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                ],
            },
            {
                target: '[data-tour-anchor="virtual-view-actions"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open virtual view actions',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Orders by status"]',
                ],
            },
            {
                target: '[data-tour-anchor="virtual-view-edit"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Edit the virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Orders by status"]',
                    '[data-tour-anchor="virtual-view-actions"]',
                ],
            },
            {
                target: '[data-tour-anchor="virtual-view-edit-name"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Rename the virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Orders by status"]',
                    '[data-tour-anchor="virtual-view-actions"]',
                    '[data-tour-anchor="virtual-view-edit"]',
                ],
                detour: [
                    {
                        target: '[data-tour-anchor="virtual-view-discard"]',
                        title: 'Discard and continue',
                    },
                ],
                suggestion: 'Orders grouped by status',
            },
            {
                target: '[data-tour-scope="manage:VirtualView"][data-tour-step="2"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Save the virtual view',
                body: "To edit a virtual view, you need to open it in the Explorer, then beside the name, there's a three-dot-menu where you can choose to **edit** or **delete** the virtual view.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Orders by status"]',
                    '[data-tour-anchor="virtual-view-actions"]',
                    '[data-tour-anchor="virtual-view-edit"]',
                    '[data-tour-anchor="virtual-view-edit-name"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:VirtualView"][data-tour-step="1"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'See the result',
                body: 'Any changes you make will affect all existing content built using the virtual view.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="virtual-view-editor"]',
            },
        ],
    },
    'delete:VirtualView': {
        scope: 'delete:VirtualView',
        title: 'Delete a virtual view',
        sources: [
            'packages/frontend/src/components/Explorer/ExploreSideBar/BasePanel.tsx',
            'packages/frontend/src/components/Explorer/ExplorePanel/index.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="delete:VirtualView"][data-tour-step="1"]',
                route: '/projects/:projectUuid/tables',
                title: 'Edit or delete a virtual view',
                body: "To edit a virtual view, you need to open it in the Explorer, then beside the name, there's a three-dot-menu where you can choose to **edit** or **delete** the virtual view.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-sql-runner"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose Query using SQL runner',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="sql-runner-editor"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Write your query',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                ],
                suggestion:
                    'SELECT status, COUNT(*) AS orders FROM jaffle.orders GROUP BY 1',
            },
            {
                target: '[data-tour-anchor="sql-runner-run"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Run the query',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-cta-menu"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open the save options',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-cta-virtual-view"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose Create virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-create-virtual-view"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click Create virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                ],
            },
            {
                target: '[data-tour-anchor="virtual-view-name"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Name the virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                ],
                suggestion: 'Orders by status',
            },
            {
                target: '[data-tour-anchor="virtual-view-create-submit"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Create the virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                ],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                ],
            },
            {
                target: '[data-tour-nav="new-chart"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose Chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-search"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Search for the table',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                ],
                suggestion: 'Orders by status',
            },
            {
                target: '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open the Virtual Views section',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-table"][data-tour-value="Orders by status"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open Orders by status',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                ],
            },
            {
                target: '[data-tour-anchor="virtual-view-actions"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open virtual view actions',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Orders by status"]',
                ],
            },
            {
                target: '[data-tour-scope="delete:VirtualView"][data-tour-step="2"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Delete the virtual view',
                body: "To edit a virtual view, you need to open it in the Explorer, then beside the name, there's a three-dot-menu where you can choose to **edit** or **delete** the virtual view.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                    '[data-tour-anchor="virtual-view-create-submit"]',
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Orders by status"]',
                    '[data-tour-anchor="virtual-view-actions"]',
                ],
            },
            {
                target: '[data-tour-anchor="modal-confirm"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Confirm the change',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="delete:VirtualView"][data-tour-step="1"]',
                route: '/projects/:projectUuid/tables',
                title: 'See the result',
                body: "To edit a virtual view, you need to open it in the Explorer, then beside the name, there's a three-dot-menu where you can choose to **edit** or **delete** the virtual view.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'create:VirtualView': {
        scope: 'create:VirtualView',
        title: 'Create a virtual view',
        sources: [
            'packages/frontend/src/components/Explorer/ExploreSideBar/ExploreNavLink.tsx',
            'packages/frontend/src/features/virtualView/components/CreateVirtualViewModal.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="create:VirtualView"][data-tour-step="1"]',
                route: '/projects/:projectUuid/tables',
                title: 'Virtual views',
                body: 'A virtual view is created in the [SQL Runner](https://docs.lightdash.com/explore/sql-runner) and lets other users reuse your custom SQL query in Lightdash.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-sql-runner"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Choose Query using SQL runner',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="sql-runner-editor"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Write your query',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                ],
                suggestion:
                    'SELECT status, COUNT(*) AS orders FROM jaffle.orders GROUP BY 1',
            },
            {
                target: '[data-tour-anchor="sql-runner-run"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Run the query',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-cta-menu"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Open the save options',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-cta-virtual-view"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Choose Create virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-create-virtual-view"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Click Create virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                ],
            },
            {
                target: '[data-tour-anchor="virtual-view-name"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Name the virtual view',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                ],
                suggestion: 'Orders by status',
            },
            {
                target: '[data-tour-scope="create:VirtualView"][data-tour-step="2"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Create the virtual view',
                body: 'To create a virtual view from the SQL Runner, select the **Create Virtual View** option from the **save** drop-down.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-cta-menu"]',
                    '[data-tour-anchor="sql-cta-virtual-view"]',
                    '[data-tour-anchor="sql-create-virtual-view"]',
                    '[data-tour-anchor="virtual-view-name"]',
                ],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-chart"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Choose Chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="explore-search"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Search for the table',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: ['[data-tour-nav="new"]', '[data-tour-nav="new-chart"]'],
                suggestion: 'Orders by status',
            },
            {
                target: '[data-tour-anchor="explore-section"][data-tour-value="Virtual Views"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Open the Virtual Views section',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                ],
            },
            {
                target: '[data-tour-scope="create:VirtualView"][data-tour-step="1"]',
                route: '/projects/:projectUuid/tables',
                title: 'See the result',
                body: 'Your virtual view will appear in the list of Tables available to explore in Lightdash. Everyone in your team can use virtual views to build queries and charts just like they would any other Table.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'view:UnderlyingData': {
        scope: 'view:UnderlyingData',
        title: 'See the records behind a number',
        sources: [
            'packages/frontend/src/components/MetricQueryData/UnderlyingDataModal.tsx',
            'packages/frontend/src/components/Explorer/ResultsCard/CellContextMenu.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:UnderlyingData"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'The Explore page',
                body: '**Results**, the raw data returned from your database',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-anchor="results-heading"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open the results',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-anchor="results-metric-cell"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click a number in the results',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="results-heading"]',
                ],
            },
            {
                target: '[data-tour-scope="view:UnderlyingData"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click View underlying data',
                body: 'Click any point on a chart or any cell in a results table and pick **View underlying data** in the action menu to see the records that make up that number.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="results-heading"]',
                    '[data-tour-anchor="results-metric-cell"]',
                ],
            },
            {
                target: '[data-tour-scope="view:UnderlyingData"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'See the result',
                body: 'From there you can export the rows as a CSV, or click **Explore from here** to open [the Explore view](https://docs.lightdash.com/explore/explore-view) with that underlying data as the starting point.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'view:SavedChart': {
        scope: 'view:SavedChart',
        title: 'Open and read a chart',
        sources: [
            'packages/frontend/src/components/Explorer/VisualizationCard/VisualizationCard.tsx',
            'packages/frontend/src/components/Explorer/ResultsCard/ResultsCard.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:SavedChart"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Share a saved chart',
                body: 'Users with access to the containing space can find the chart under **Browse → All saved charts**, or you can send them its URL — a URL copied at any screen size opens the full chart for everyone.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-scope="view:SavedChart"][data-tour-look="1"]',
                title: 'The chart shows the answer',
                body: '**Chart**, where you visualize the results',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:SavedChart"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open the results',
                body: '**Results**, the raw data returned from your database',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-scope="view:SavedChart"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'See the result',
                body: 'Saved charts and dashboard tiles make good starting points for exploration.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:ExportCsv': {
        scope: 'manage:ExportCsv',
        title: "Download a chart's results",
        sources: [
            'packages/frontend/src/components/ExportResults/index.tsx',
            'packages/frontend/src/components/Explorer/ResultsCard/ResultsCard.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:ExportCsv"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Download results or a chart image',
                body: 'Click the export icon on a chart to download it as JPEG, PNG, SVG, PDF, or JSON, with an opaque or transparent background.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-anchor="results-heading"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open the results',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:ExportCsv"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open the export dialog',
                body: 'You can also download the results table as a CSV or an Excel spreadsheet, or export it to a Google Sheet if your organization has [that set up](https://docs.lightdash.com/integrations/google-sheets).',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="results-heading"]',
                ],
            },
            {
                target: '[data-tour-anchor="export-download"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Download',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
                detour: [
                    {
                        target: '[data-tour-anchor="export-choose-download"]',
                        title: 'Click Download data',
                    },
                ],
            },
            {
                target: '[data-tour-scope="manage:ExportCsv"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'See the result',
                body: "Viewers don't get the result scope choice; their downloads contain the visible table rows.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:SavedChart': {
        scope: 'manage:SavedChart',
        title: 'Save a chart',
        sources: [
            'packages/frontend/src/components/Explorer/SavedChartsHeader/index.tsx',
            'packages/frontend/src/components/Explorer/SaveChartButton/index.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:SavedChart"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Save your chart',
                body: 'Saving a chart lets you share it, add it to a dashboard, or come back to it later. A saved chart re-runs its query every time you open it, so it always shows the latest data in your database.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-chart"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose Chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="explore-table"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open a table',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]', '[data-tour-nav="new-chart"]'],
            },
            {
                target: '[data-tour-anchor="explore-metric"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Select a metric',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-table"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-dimension"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Select a dimension',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-table"]',
                    '[data-tour-anchor="explore-metric"]',
                ],
            },
            {
                target: '[data-tour-anchor="run-query"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Run the query',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-table"]',
                    '[data-tour-anchor="explore-metric"]',
                    '[data-tour-anchor="explore-dimension"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:SavedChart"][data-tour-step="2"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click Save chart',
                body: 'Click **Save chart** at the top of the page, then give the chart a useful name and description.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-table"]',
                    '[data-tour-anchor="explore-metric"]',
                    '[data-tour-anchor="explore-dimension"]',
                    '[data-tour-anchor="run-query"]',
                ],
            },
            {
                target: '[data-tour-anchor="chart-save-to-space"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose to save it in a space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="chart-save-next"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Click Next to accept the suggested name',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-anchor="chart-save-to-space"]'],
            },
            {
                target: '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Choose the Shared space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="chart-save-to-space"]',
                    '[data-tour-anchor="chart-save-next"]',
                ],
            },
            {
                target: '[data-tour-anchor="chart-save-submit"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Save the chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="chart-save-to-space"]',
                    '[data-tour-anchor="chart-save-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:SavedChart"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'See the result',
                body: 'A chart saved to a [space](https://docs.lightdash.com/explore/spaces) can be shared on its own and reused across multiple dashboards.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:VerifiedContent': {
        scope: 'manage:VerifiedContent',
        title: 'Edit a verified chart',
        sources: [
            'packages/frontend/src/components/Explorer/SavedChartsHeader/index.tsx',
            'packages/frontend/src/components/Explorer/SaveChartButton/index.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:VerifiedContent"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Who can edit or delete verified content',
                body: 'Editing or deleting a verified chart or dashboard requires the usual permission to edit or delete that content, plus **Edit or delete verified charts and dashboards** (**manage:VerifiedContent**). The original verifier can also change the content without that additional scope.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-anchor="chart-actions"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: "Open the chart's actions",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-anchor="verify-chart"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Verify the chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="chart-actions"]',
                ],
            },
            {
                target: '[data-tour-anchor="edit-chart"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Edit the chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="chart-actions"]',
                    '[data-tour-anchor="verify-chart"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-dimension"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Select a dimension',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="chart-actions"]',
                    '[data-tour-anchor="verify-chart"]',
                    '[data-tour-anchor="edit-chart"]',
                ],
            },
            {
                target: '[data-tour-anchor="run-query"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Run the query',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="chart-actions"]',
                    '[data-tour-anchor="verify-chart"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="explore-dimension"]',
                ],
            },
            {
                target: '[data-tour-anchor="save-chart-changes"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Save changes',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="chart-actions"]',
                    '[data-tour-anchor="verify-chart"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="explore-dimension"]',
                    '[data-tour-anchor="run-query"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:VerifiedContent"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Save and verify the changed chart',
                body: 'The confirmation dialog comes in two variants:',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="chart-actions"]',
                    '[data-tour-anchor="verify-chart"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="explore-dimension"]',
                    '[data-tour-anchor="run-query"]',
                    '[data-tour-anchor="save-chart-changes"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:VerifiedContent"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'See the result',
                body: "**If you can verify content** (you have verify permission, or you're the original verifier), you're offered the choice to keep the badge as part of saving. Choosing **Save & verify** re-approves the current version and keeps the badge (updating the verification timestamp to your save); choosing **Save** drops it.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="verified-edit-pending"]',
            },
        ],
    },
    'manage:ContentVerification': {
        scope: 'manage:ContentVerification',
        title: 'Verify a chart',
        sources: [
            'packages/frontend/src/components/Explorer/SavedChartsHeader/index.tsx',
            'packages/frontend/src/components/Explorer/SavedChartsHeader/ChartActionsMenu.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:ContentVerification"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Who can verify content',
                body: 'Organization and project admins and developers can verify or unverify charts and dashboards.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-anchor="chart-actions"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: "Open the chart's actions",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:ContentVerification"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Verify',
                body: 'Admins and developers can verify content directly from the chart or dashboard, or from the verification panel in project settings.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="chart-actions"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:ContentVerification"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'See the result',
                body: 'Each verified item gets a green checkmark badge that shows who verified it and when. Verification always reflects the current state of the content.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
        covers: ['view:ContentVerification'],
    },
    'view:CompiledSql': {
        scope: 'view:CompiledSql',
        title: 'Read the SQL behind a chart',
        sources: [
            'packages/frontend/src/components/Explorer/SqlCard/SqlCard.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:CompiledSql"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'The Explore view',
                body: 'A **Table** is the starting point for querying data in Lightdash.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-scope="view:CompiledSql"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open the SQL',
                body: '**SQL**, the generated SQL that produced the results',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-scope="view:CompiledSql"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'See the result',
                body: "Open a Table and you're in the Explore view: pick the dimensions and metrics you want, sort the results, and Lightdash writes the SQL for you.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:ChangeCsvResults': {
        scope: 'manage:ChangeCsvResults',
        title: 'Change the rows exported',
        sources: ['packages/frontend/src/components/ExportResults/index.tsx'],
        steps: [
            {
                target: '[data-tour-scope="manage:ChangeCsvResults"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Choosing how many rows an export contains',
                body: "The download dialog also asks how the values should be written — **Formatted** keeps the table's presentation, **Raw** uses the underlying values — and, for interactive viewers and above, the **result scope**:",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-anchor="results-heading"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open the results',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-anchor="export-results"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open the export dialog',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="results-heading"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:ChangeCsvResults"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Choose All results',
                body: "Viewers don't get the result scope choice; their downloads contain the visible table rows.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="results-heading"]',
                    '[data-tour-anchor="export-results"]',
                ],
                detour: [
                    {
                        target: '[data-tour-anchor="export-choose-download"]',
                        title: 'Click Download data',
                    },
                ],
            },
            {
                target: '[data-tour-anchor="export-download"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Download',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="manage:ChangeCsvResults"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'See the result',
                body: "Viewers don't get the result scope choice; their downloads contain the visible table rows.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="csv-export-pending"]',
            },
        ],
    },
    'view:Space': {
        scope: 'view:Space',
        title: 'Find content through spaces',
        sources: [
            'packages/frontend/src/pages/Space.tsx',
            'packages/frontend/src/components/NavBar/BrowseMenu.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:Space"][data-tour-step="1"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'Spaces',
                body: 'Spaces are kind of like folders. All saved charts and dashboards exist in a Space and can only be in one Space at a time.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/home',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:Space"][data-tour-step="2"]',
                route: '/projects/:projectUuid/home',
                title: 'Open All Spaces',
                body: '**Browse** in the navbar lists every saved chart, dashboard, and [space](https://docs.lightdash.com/explore/spaces) you and your teammates have made in the project.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="space-row"][data-tour-value="Training"]',
                route: '/projects/:projectUuid/home',
                title: 'Open Training',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:Space"][data-tour-step="1"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'See the result',
                body: 'To access Spaces, you can either select a Space from the drop-down list in **Browse** or you can click on the Lightdash icon and select your Space from the homepage.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'view:PinnedItems': {
        scope: 'view:PinnedItems',
        title: 'Find pinned content on the homepage',
        sources: [
            'packages/frontend/src/components/PinnedItemsPanel/index.tsx',
            'packages/frontend/src/ee/features/homepageBuilder/DayOneHomepage.tsx',
            'packages/frontend/src/components/NavBar/MainNavBarContent.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:PinnedItems"][data-tour-step="1"]',
                route: '/projects/:projectUuid/home',
                title: 'Browsing instead of searching',
                body: "When you don't know what you're looking for yet, browse. Your home page lists recent and pinned content as soon as you land in Lightdash.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/dashboards',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-dashboards"]',
                route: '/projects/:projectUuid/dashboards',
                title: 'Open All dashboards',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-scope="view:PinnedItems"][data-tour-step="2"]',
                route: '/projects/:projectUuid/dashboards',
                title: 'Click the Lightdash logo to go back home',
                body: 'Click the Lightdash icon in the top-left corner to get back to it from anywhere.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                ],
            },
            {
                target: '[data-tour-anchor="pinned-item"][data-tour-value="Jaffle Shop overview"]',
                route: '/projects/:projectUuid/dashboards',
                title: 'Open Jaffle Shop overview',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="home"]',
                route: '/projects/:projectUuid/home',
                title: 'Click the Lightdash logo to go back home',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:PinnedItems"][data-tour-step="1"]',
                route: '/projects/:projectUuid/home',
                title: 'See the result',
                body: 'Editors, developers, admins, and custom roles with **Manage pinned items** can pin a saved chart, dashboard, space, or data app from its three-dot menu or header action menu.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="home"]'],
            },
        ],
    },
    'manage:PinnedItems': {
        scope: 'manage:PinnedItems',
        title: 'Pin content to the homepage',
        sources: [
            'packages/frontend/src/components/PinnedItemsPanel/index.tsx',
            'packages/frontend/src/ee/features/homepageBuilder/DayOneHomepage.tsx',
            'packages/frontend/src/components/common/ResourceView/ResourceActionMenuItems.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:PinnedItems"][data-tour-step="1"]',
                route: '/projects/:projectUuid/home',
                title: 'Pin content',
                body: 'Editors, developers, admins, and custom roles with **Manage pinned items** can pin a saved chart, dashboard, space, or data app from its three-dot menu or header action menu.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-spaces"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Open All Spaces',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="resource-actions"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Open the actions menu on a space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:PinnedItems"][data-tour-step="2"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Click Pin to homepage',
                body: 'Select **Pin to homepage** or **Unpin from homepage**.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                    '[data-tour-anchor="resource-actions"]',
                ],
            },
            {
                target: '[data-tour-nav="home"]',
                route: '/projects/:projectUuid/home',
                title: 'Click the Lightdash logo to go back home',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="manage:PinnedItems"][data-tour-step="1"]',
                route: '/projects/:projectUuid/home',
                title: 'See the result',
                body: 'Pins appear on Homepage only when its layout includes a Collection with **Pinned** as the source, or when they were imported into a hand-picked Collection.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="home"]'],
            },
        ],
    },
    'manage:Validation': {
        scope: 'manage:Validation',
        title: 'Find broken content with the validator',
        sources: [
            'packages/frontend/src/components/SettingsValidator/index.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:Validation"][data-tour-step="1"]',
                route: '/generalSettings/projectManagement/:projectUuid/validator',
                title: 'Validating your content',
                body: "The content validation page can be opened by [admins and developers](https://docs.lightdash.com/workspace-admin/roles) from the project settings. There you'll see any broken charts or dashboards in your project and information about what is causing the errors.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="settings"]',
                route: '/generalSettings/projectManagement/:projectUuid/validator',
                title: 'Click Settings',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="project-settings"]',
                route: '/generalSettings/projectManagement/:projectUuid/validator',
                title: 'Open Project settings',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="settings"]'],
            },
            {
                target: '[data-tour-nav="validator"]',
                route: '/generalSettings/projectManagement/:projectUuid/validator',
                title: 'Open the Validator',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="settings"]',
                    '[data-tour-nav="project-settings"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Validation"][data-tour-step="2"]',
                route: '/generalSettings/projectManagement/:projectUuid/validator',
                title: 'Click Run validation',
                body: 'Your project is validated any time the content validator is run.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="settings"]',
                    '[data-tour-nav="project-settings"]',
                    '[data-tour-nav="validator"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Validation"][data-tour-step="1"]',
                route: '/generalSettings/projectManagement/:projectUuid/validator',
                title: 'See the result',
                body: 'The validator will show you any errors caused by metrics or dimensions which no longer exist, have been renamed, or have invalid definitions.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="validation-running"]',
            },
        ],
    },
    'manage:Space': {
        scope: 'manage:Space',
        title: 'Share a space with the right people',
        sources: [
            'packages/frontend/src/components/common/ResourceView/InfiniteResourceTable.tsx',
            'packages/frontend/src/components/common/ShareSpaceModal/ShareSpaceModalShared.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:Space"][data-tour-step="1"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Managing access to a Space',
                body: 'By default, when you create a Space, it has Inherited Access—inheriting permissions from the project (for root-level spaces) or from the parent space (for nested spaces). You can change a space to Restricted Access to limit it to only invited users and admins.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-spaces"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'Open All Spaces',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="space-row"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'Open a space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                ],
            },
            {
                target: '[data-tour-anchor="space-actions"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: "Open the space's actions menu",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                    '[data-tour-anchor="space-row"]',
                ],
            },
            {
                target: '[data-tour-anchor="space-share"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'Click Share',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                    '[data-tour-anchor="space-row"]',
                    '[data-tour-anchor="space-actions"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Space"][data-tour-step="2"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'Choose Restricted access',
                body: 'From there, you can choose between **Inherited Access** and **Restricted Access**.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                    '[data-tour-anchor="space-row"]',
                    '[data-tour-anchor="space-actions"]',
                    '[data-tour-anchor="space-share"]',
                ],
            },
            {
                target: '[data-tour-anchor="modal-confirm"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'Confirm the change',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="modal-close"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Close the dialog',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-anchor="modal-close"]'],
            },
            {
                target: '[data-tour-nav="all-spaces"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Open All Spaces',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="modal-close"]',
                    '[data-tour-nav="browse"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Space"][data-tour-step="1"]',
                route: '/projects/:projectUuid/spaces',
                title: 'See the result',
                body: '**Only admins and members that are invited to a Space with Restricted Access have access to it.**',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="modal-close"]',
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                ],
            },
        ],
    },
    'create:Space': {
        scope: 'create:Space',
        title: 'Create a space',
        sources: [
            'packages/frontend/src/components/common/SpaceActionModal/CreateSpaceModalContent.tsx',
            'packages/frontend/src/pages/Space.tsx',
            'packages/frontend/src/components/common/SpaceActionModal/index.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="create:Space"][data-tour-step="1"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'Spaces',
                body: 'Spaces are kind of like folders. All saved charts and dashboards exist in a Space and can only be in one Space at a time.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-spaces"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Open All Spaces',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="add-space"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Click Add',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                ],
            },
            {
                target: '[data-tour-anchor="space-name"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Name your space',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                    '[data-tour-anchor="add-space"]',
                ],
                suggestion: 'Customer Success',
            },
            {
                target: '[data-tour-scope="create:Space"][data-tour-look="1"]',
                title: 'Choose who can see it',
                body: 'Root-level Spaces also ask you to pick an access mode as you create them: **Inherited access** (everyone in the project, the default) or **Restricted access** (only invited users and groups) — see [managing access](https://docs.lightdash.com/explore/spaces#managing-access-to-a-space) for what each means.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="create:Space"][data-tour-step="2"]',
                route: '/projects/:projectUuid/spaces',
                title: 'Click Create',
                body: 'Editors and above can create Spaces.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-spaces"]',
                    '[data-tour-anchor="add-space"]',
                    '[data-tour-anchor="space-name"]',
                ],
            },
            {
                target: '[data-tour-scope="create:Space"][data-tour-step="1"]',
                route: '/projects/:projectUuid/spaces/:spaceUuid',
                title: 'See the result',
                body: 'You become an admin of the Space you created, and it appears in **Browse** and on the **All spaces** page alongside the rest.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:CustomSqlTableCalculations': {
        scope: 'manage:CustomSqlTableCalculations',
        title: 'Add a SQL table calculation',
        sources: [
            'packages/frontend/src/features/tableCalculation/components/TableCalculationModal.tsx',
            'packages/frontend/src/components/common/Table/ScrollableTable/TableHeader.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:CustomSqlTableCalculations"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'When to use table calculations',
                body: "Sometimes the predefined metrics and dimensions aren't quite enough, and you might need to perform additional calculations for specific visualizations, create specialized metrics for particular analyses, or build custom logic to better communicate your insights.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-anchor="edit-chart"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Edit the chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-anchor="results-heading"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Open the results',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                ],
            },
            {
                target: '[data-tour-anchor="add-table-calculation"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Add a table calculation',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="results-heading"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:CustomSqlTableCalculations"][data-tour-look="1"]',
                title: 'Formula is the default, SQL is one click away',
                body: 'When you create a new [table calculation](https://docs.lightdash.com/explore/table-calculations), **Formula** is the default input mode. You can switch to the SQL editor any time.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="table-calc-sql-mode"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Switch to SQL',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="results-heading"]',
                    '[data-tour-anchor="add-table-calculation"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:CustomSqlTableCalculations"][data-tour-look="2"]',
                title: 'The calculation is raw SQL over the results',
                body: 'To reference the metrics and dimensions in your results table, you can either use the autocomplete, or you can manually write the full field name using the format **${table_name.field_name}**.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="table-calc-sql"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Write the SQL',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="results-heading"]',
                    '[data-tour-anchor="add-table-calculation"]',
                    '[data-tour-anchor="table-calc-sql-mode"]',
                ],
                suggestion:
                    'SUM(${orders.unique_order_count}) OVER (ORDER BY ${orders.order_date_month})',
            },
            {
                target: '[data-tour-anchor="table-calc-name"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Name the calculation',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="results-heading"]',
                    '[data-tour-anchor="add-table-calculation"]',
                    '[data-tour-anchor="table-calc-sql-mode"]',
                    '[data-tour-anchor="table-calc-sql"]',
                ],
                suggestion: 'Running order count',
            },
            {
                target: '[data-tour-scope="manage:CustomSqlTableCalculations"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'Create the calculation',
                body: 'With either mode you can build mathematical, True/False, text, and date-based calculations on top of your results.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="edit-chart"]',
                    '[data-tour-anchor="results-heading"]',
                    '[data-tour-anchor="add-table-calculation"]',
                    '[data-tour-anchor="table-calc-sql-mode"]',
                    '[data-tour-anchor="table-calc-sql"]',
                    '[data-tour-anchor="table-calc-name"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:CustomSqlTableCalculations"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid/edit',
                title: 'See the result',
                body: 'You add table calculations in the Explore view and they appear as green columns in your results table (remember, [dimensions](https://docs.lightdash.com/semantic-layer/dimensions) are blue, and [metrics](https://docs.lightdash.com/semantic-layer/metrics) are orange).',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'view:AiAgent': {
        scope: 'view:AiAgent',
        title: 'Explore an AI agent',
        sources: [
            'packages/frontend/src/ee/pages/AiAgents/AiAgentNewThreadPage.tsx',
            'packages/frontend/src/ee/features/aiCopilot/components/AgentSelector/AgentSelector.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:AiAgent"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'AI agents',
                body: "Lightdash AI agents let your team ask questions in natural language and get answers built from your semantic layer — the saved dashboards, metrics, dimensions, joins, and descriptions you've already defined.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="ask-ai"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Click Ask AI',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:AiAgent"][data-tour-step="2"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Open the agent dropdown',
                body: 'Think of AI agents as your specialized analysts - each one can be configured to focus on specific areas of your business.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="ask-ai"]'],
            },
            {
                target: '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Choose Jaffle analyst',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:AiAgent"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'See the result',
                body: '**Ask questions in natural language** - Simply type what you want to know about your data, like "What\'s our total revenue by region?" or "Show me user growth over the last 6 months"',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:AiAgent"][data-tour-result="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Read the agent description',
                body: 'Think of AI agents as your specialized analysts - each one can be configured to focus on specific areas of your business.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:AiAgent': {
        scope: 'manage:AiAgent',
        title: 'Create and configure an AI agent',
        sources: [
            'packages/frontend/src/ee/features/aiCopilot/components/AgentSelector/AgentSelector.tsx',
            'packages/frontend/src/ee/features/aiCopilot/components/AiAgentFormSetup.tsx',
            'packages/frontend/src/ee/pages/AiAgents/AiAgentNewThreadPage.tsx',
            'packages/frontend/src/ee/features/aiCopilot/components/AgentSettingsActionBar.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:AiAgent"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Set up AI agents',
                body: 'Set up an agent around a clear job, give it access to the right data and context, then test it with real questions before sharing it more widely.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="ask-ai"]',
                route: '/projects/:projectUuid/ai-agents/new',
                title: 'Click Ask AI',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="agent-selector"]',
                route: '/projects/:projectUuid/ai-agents/new',
                title: 'Open the agent dropdown',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="ask-ai"]'],
            },
            {
                target: '[data-tour-scope="manage:AiAgent"][data-tour-look="1"]',
                title: 'Every agent starts from this dropdown',
                body: 'Go to the agent dropdown and click **Create new agent** at the bottom',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="agent-new"]',
                route: '/projects/:projectUuid/ai-agents/new',
                title: 'Choose Create new agent',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:AiAgent"][data-tour-look="2"]',
                title: 'A name your team will recognise',
                body: 'Give your agent a memorable name and visual identity',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="agent-name"]',
                route: '/projects/:projectUuid/ai-agents/new',
                title: 'Name the agent',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-new"]',
                ],
                suggestion: 'Sales analyst',
            },
            {
                target: '[data-tour-scope="manage:AiAgent"][data-tour-look="3"]',
                title: 'Instructions shape every answer',
                body: 'Add the role, priorities, analysis defaults, constraints, and communication style that should apply to every conversation with this agent.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="agent-instructions"]',
                route: '/projects/:projectUuid/ai-agents/new',
                title: 'Write the instructions',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-new"]',
                    '[data-tour-anchor="agent-name"]',
                ],
                suggestion:
                    'You are the analyst for a jaffle shop. Answer questions about customers, orders and payments, and prefer charts over tables.',
            },
            {
                target: '[data-tour-scope="manage:AiAgent"][data-tour-step="2"]',
                route: '/projects/:projectUuid/ai-agents/new',
                title: 'Click Create agent',
                body: 'By default, your agent is available to everyone in the project.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-new"]',
                    '[data-tour-anchor="agent-name"]',
                    '[data-tour-anchor="agent-instructions"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:AiAgent"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'See the result',
                body: 'By default, agents have data access enabled so they can analyze actual query results and provide insights based on the data.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:AiAgentDocument': {
        scope: 'manage:AiAgentDocument',
        title: 'Always include a knowledge document in context',
        sources: [
            'packages/frontend/src/ee/features/aiCopilot/components/AiAgentKnowledgeDocumentModal.tsx',
            'packages/frontend/src/ee/features/aiCopilot/components/AiAgentKnowledgeFilesSection.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Knowledge documents',
                body: 'Knowledge documents let you upload longer reference material — glossaries, business policies, supporting context, and internal procedures — that your agent can consult while answering questions.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="ask-ai"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Click Ask AI',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="agent-selector"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Open the agent dropdown',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="ask-ai"]'],
            },
            {
                target: '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Choose Jaffle analyst',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                ],
            },
            {
                target: '[data-tour-anchor="agent-settings"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: "Open the agent's settings",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                ],
            },
            {
                target: '[data-tour-anchor="knowledge-document"][data-tour-value="Jaffle shop glossary"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Choose Jaffle shop glossary',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                    '[data-tour-anchor="agent-settings"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-look="1"]',
                title: 'Read the summary the agent sees',
                body: "The agent always sees this summary, so it knows the document is available and what's in it. By default, it only reads the full content when a question actually calls for it (**on-demand retrieval**), which keeps conversations fast.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="knowledge-document-open"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Open the document',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                    '[data-tour-anchor="agent-settings"]',
                    '[data-tour-anchor="knowledge-document"][data-tour-value="Jaffle shop glossary"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-look="2"]',
                title: 'Read the document',
                body: "**The agent decides when to open a document.** If your document is never being used, the summary probably isn't specific enough about what it's for.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="modal-close"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Close the dialog',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                    '[data-tour-anchor="agent-settings"]',
                    '[data-tour-anchor="knowledge-document"][data-tour-value="Jaffle shop glossary"]',
                    '[data-tour-anchor="knowledge-document-open"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-step="2"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Turn on Always include in context',
                body: "For documents the agent should apply to every question — not just the ones where the summary happens to match — flip the **Always include in context** toggle in the document's settings panel.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                    '[data-tour-anchor="agent-settings"]',
                    '[data-tour-anchor="knowledge-document"][data-tour-value="Jaffle shop glossary"]',
                    '[data-tour-anchor="knowledge-document-open"]',
                    '[data-tour-anchor="modal-close"]',
                ],
            },
            {
                target: '[data-tour-anchor="modal-confirm"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Confirm the change',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'See the result',
                body: 'The documents table shows an **Always included** or **On demand** status chip per document so you can see at a glance which documents will be in every prompt.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
        covers: ['view:AiAgentDocument'],
    },
    'create:AiAgentThread': {
        scope: 'create:AiAgentThread',
        title: 'Ask an AI agent',
        sources: [
            'packages/frontend/src/ee/features/aiCopilot/components/ChatElements/AgentChatAssistantBubble.tsx',
            'packages/frontend/src/ee/features/aiCopilot/components/ChatElements/AgentChatInput.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="create:AiAgentThread"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/threads/:threadUuid',
                title: 'AI agents',
                body: "Lightdash AI agents let your team ask questions in natural language and get answers built from your semantic layer — the saved dashboards, metrics, dimensions, joins, and descriptions you've already defined.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="ask-ai"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Click Ask AI',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="ai-suggestion"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Pick a suggested question',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="ask-ai"]'],
            },
            {
                target: '[data-tour-scope="create:AiAgentThread"][data-tour-step="2"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Send your question',
                body: 'An agent picks the relevant models and metrics, builds and runs the query with the right filters and [parameters](https://docs.lightdash.com/semantic-layer/parameters), and returns the result as the chart, table, summary, or interactive data app that fits the question.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="ai-suggestion"]',
                ],
            },
            {
                target: '[data-tour-scope="create:AiAgentThread"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/threads/:threadUuid',
                title: 'See the result',
                body: 'Because every answer runs through the semantic layer, it respects the same project permissions and user attributes as the rest of Lightdash.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="ai-working"]',
            },
            {
                target: '[data-tour-scope="create:AiAgentThread"][data-tour-result="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/threads/:threadUuid',
                title: 'Read the answer',
                body: 'This ensures that the AI generates accurate queries and visualizations based on your specific data context.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="create:AiAgentThread"][data-tour-result="2"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/threads/:threadUuid',
                title: 'The chart the agent built',
                body: '**Get instant visualizations** - Receive bar charts, time series, and tables automatically generated based on your questions',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="create:AiAgentThread"][data-tour-result="3"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/threads/:threadUuid',
                title: 'Rate the answer',
                body: 'With the setting enabled, Lightdash scans every AI agent turn for signs the answer was probably wrong — a missing metric, an ambiguous field, a gap in your project context — and files an issue for each root cause it identifies.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'create:AiDeepResearch': {
        scope: 'create:AiDeepResearch',
        title: 'Run deep research and read its report',
        sources: [
            'packages/frontend/src/ee/features/aiCopilot/components/DeepResearch/DeepResearchRunCard.tsx',
            'packages/frontend/src/ee/features/aiCopilot/components/DeepResearch/DeepResearchReport.tsx',
            'packages/frontend/src/ee/features/aiCopilot/components/ChatElements/AgentChatInput.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="create:AiDeepResearch"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/deep-research/:runUuid',
                title: 'When to use deep research',
                body: 'Choose deep research for multi-step investigations that need cross-checking, several data cuts, or a report you can save and revisit.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="ask-ai"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Click Ask AI',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="composer-options"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Open the composer options',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="ask-ai"]'],
            },
            {
                target: '[data-tour-scope="create:AiDeepResearch"][data-tour-step="2"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Turn on Deep research',
                body: "Deep research uses the selected AI agent's configuration, including its instructions, semantic-layer access, knowledge documents, project and repository context, and enabled tools.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="composer-options"]',
                ],
            },
            {
                target: '[data-tour-anchor="agent-thread"][data-tour-value="Why returns rose in the spring"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Open the Why returns rose in the spring thread',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="create:AiDeepResearch"][data-tour-look="1"]',
                title: 'The run card stays with the question',
                body: 'The run card stays next to the question that started it and shows the latest phase, elapsed time, warehouse-query count, finding count, and recent activity.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="research-report-open"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid',
                title: 'Open the full report',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="agent-thread"][data-tour-value="Why returns rose in the spring"]',
                ],
            },
            {
                target: '[data-tour-scope="create:AiDeepResearch"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/deep-research/:runUuid',
                title: 'See the result',
                body: 'Select **Open full report** from a completed or partially completed run card. Reports include a contents rail on larger screens so you can jump between findings.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:ProjectHomepage': {
        scope: 'manage:ProjectHomepage',
        title: 'Edit the project homepage',
        sources: [
            'packages/frontend/src/ee/features/homepageBuilder/HomepageEditor.tsx',
            'packages/frontend/src/ee/features/homepageBuilder/PublishedHomepage.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:ProjectHomepage"][data-tour-step="1"]',
                route: '/projects/:projectUuid/home',
                title: 'Build a homepage',
                body: 'Project admins, organization admins, and custom roles with **Manage project homepage** can select **Customize homepage** from the project homepage.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="home"]',
                route: '/projects/:projectUuid/homepage-builder',
                title: 'Click the Lightdash logo to go back home',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="customize-homepage"]',
                route: '/projects/:projectUuid/homepage-builder',
                title: 'Click Customize homepage',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="home"]'],
            },
            {
                target: '[data-tour-scope="manage:ProjectHomepage"][data-tour-look="1"]',
                title: 'The block library',
                body: 'Click a block to add it, or drag it to a specific position.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="homepage-block"][data-tour-value="Call to action"]',
                route: '/projects/:projectUuid/homepage-builder',
                title: 'Add the Call to action block',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="home"]',
                    '[data-tour-anchor="customize-homepage"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:ProjectHomepage"][data-tour-step="2"]',
                route: '/projects/:projectUuid/homepage-builder',
                title: 'Click Publish',
                body: 'Publishing saves the entire current draft as the published version. Future edits remain in the draft until the next publication.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="home"]',
                    '[data-tour-anchor="customize-homepage"]',
                    '[data-tour-anchor="homepage-block"][data-tour-value="Call to action"]',
                ],
            },
            {
                target: '[data-tour-anchor="modal-confirm"]',
                route: '/projects/:projectUuid/homepage-builder',
                title: 'Confirm the change',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="home"]',
                route: '/projects/:projectUuid/homepage-builder',
                title: 'Click the Lightdash logo to go back home',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-anchor="modal-confirm"]'],
            },
            {
                target: '[data-tour-scope="manage:ProjectHomepage"][data-tour-step="1"]',
                route: '/projects/:projectUuid/home',
                title: 'See the result',
                body: 'The builder uses the same layout as the published page. Changes save automatically as a draft, but viewers continue to see the last published version until you publish again.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'view:DataApp': {
        scope: 'view:DataApp',
        title: 'Open and inspect a data app',
        sources: [
            'packages/frontend/src/features/apps/AppIframePreview.tsx',
            'packages/frontend/src/features/apps/AppInspectorPanel.tsx',
            'packages/frontend/src/pages/AppPreviewTest.tsx',
            'packages/frontend/src/features/apps/components/AppActionsMenu.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:DataApp"][data-tour-step="1"]',
                route: '/projects/:projectUuid/apps/:appUuid/view',
                title: 'Sharing an app',
                body: "Access to a data app combines the user's **project role** with their **space access** or [direct content role](https://docs.lightdash.com/workspace-admin/direct-access#how-roles-combine).",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/apps/:appUuid/view',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-apps"]',
                route: '/projects/:projectUuid/apps/:appUuid/view',
                title: 'Open All data apps',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="app-row"][data-tour-value="Jaffle pulse"]',
                route: '/projects/:projectUuid/apps/:appUuid/view',
                title: 'Open Jaffle pulse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]', '[data-tour-nav="all-apps"]'],
            },
            {
                target: '[data-tour-scope="view:DataApp"][data-tour-look="1"]',
                title: 'Read Jaffle pulse',
                body: '**Dashboard** - a single-page layout with multiple charts and KPIs, optimized for at-a-glance reading.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="app-actions"]',
                route: '/projects/:projectUuid/apps/:appUuid/view',
                title: "Open the app's actions",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-apps"]',
                    '[data-tour-anchor="app-row"][data-tour-value="Jaffle pulse"]',
                ],
            },
            {
                target: '[data-tour-scope="view:DataApp"][data-tour-step="2"]',
                route: '/projects/:projectUuid/apps/:appUuid/view',
                title: 'Click View network',
                body: 'The inspector is a tabbed network panel that captures everything the running app talks to. Open it from **View network** in the preview header.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-apps"]',
                    '[data-tour-anchor="app-row"][data-tour-value="Jaffle pulse"]',
                    '[data-tour-anchor="app-actions"]',
                ],
            },
            {
                target: '[data-tour-scope="view:DataApp"][data-tour-step="1"]',
                route: '/projects/:projectUuid/apps/:appUuid/view',
                title: 'See the result',
                body: 'Users with **Can view** access to the space can open the app and interact with it (if their project role allows it).',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:DataApp"][data-tour-result="1"]',
                route: '/projects/:projectUuid/apps/:appUuid/view',
                title: 'Read the network activity',
                body: 'Both tabs are always visible so you can see at a glance whether the app has run any queries or external requests yet.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'create:DataApp': {
        scope: 'create:DataApp',
        title: 'Create a data app',
        sources: [
            'packages/frontend/src/features/apps/AppResourcePicker.tsx',
            'packages/frontend/src/features/apps/AppTemplatePicker.tsx',
            'packages/frontend/src/pages/AppGenerate.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="create:DataApp"][data-tour-step="1"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'Creating a new app',
                body: "You create a new data app from the 'New' menu in the navigation bar.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/apps/generate',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-app"]',
                route: '/projects/:projectUuid/apps/generate',
                title: 'Choose Data App',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-scope="create:DataApp"][data-tour-look="1"]',
                title: 'Every app starts from a template',
                body: 'Every new app starts from a template.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="create:DataApp"][data-tour-step="2"]',
                route: '/projects/:projectUuid/apps/generate',
                title: 'Choose the Dashboard template',
                body: 'After picking a template, you write your first prompt.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]', '[data-tour-nav="new-app"]'],
            },
            {
                target: '[data-tour-anchor="app-prompt"]',
                route: '/projects/:projectUuid/apps/generate',
                title: 'Describe the app you want',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [],
                suggestion:
                    'A one-page pulse of orders, revenue and top customers, with a filter on order status',
            },
            {
                target: '[data-tour-scope="create:DataApp"][data-tour-look="2"]',
                title: 'Attach charts or a dashboard for context',
                body: 'The more context you give the agent, the better the result.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="create:DataApp"][data-tour-look="3"]',
                title: 'Send starts the build',
                body: 'If the prompt is vague, the agent will ask one or more clarifying questions - things like the topic, the audience, or the key metrics you want to highlight - before it starts building. If your prompt is already specific enough, it skips straight to the build.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/apps/generate',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-anchor="app-prompt"]'],
            },
            {
                target: '[data-tour-nav="all-apps"]',
                route: '/projects/:projectUuid/apps/generate',
                title: 'Open All data apps',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="app-prompt"]',
                    '[data-tour-nav="browse"]',
                ],
            },
            {
                target: '[data-tour-anchor="app-row"][data-tour-value="Jaffle pulse"]',
                route: '/projects/:projectUuid/apps/generate',
                title: 'Open Jaffle pulse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="app-prompt"]',
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-apps"]',
                ],
            },
            {
                target: '[data-tour-anchor="app-continue-building"]',
                route: '/projects/:projectUuid/apps/generate',
                title: 'Click Continue building',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="app-prompt"]',
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-apps"]',
                    '[data-tour-anchor="app-row"][data-tour-value="Jaffle pulse"]',
                ],
            },
            {
                target: '[data-tour-scope="create:DataApp"][data-tour-look="4"]',
                title: 'Every prompt makes a new version',
                body: 'Every prompt you send creates a new version of the app. The agent works from the current app source, so follow-up prompts like "make the header smaller" or "swap the bar chart for a line chart" land as targeted changes instead of full rewrites.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="create:DataApp"][data-tour-step="1"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'See the result',
                body: 'If a recent prompt took the app in the wrong direction, you can roll back to any earlier ready version and keep iterating from there.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:DataApp': {
        scope: 'manage:DataApp',
        title: 'Share a data app with your team',
        sources: [
            'packages/frontend/src/features/apps/components/AppHeader.tsx',
            'packages/frontend/src/features/apps/components/AppActionsMenu.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:DataApp"][data-tour-step="1"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'Sharing an app',
                body: 'Newly created apps are personal - only you can see them.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-apps"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'Open All data apps',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="app-row"][data-tour-value="Jaffle pulse"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'Open Jaffle pulse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]', '[data-tour-nav="all-apps"]'],
            },
            {
                target: '[data-tour-anchor="app-actions"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: "Open the app's actions",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-apps"]',
                    '[data-tour-anchor="app-row"][data-tour-value="Jaffle pulse"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:DataApp"][data-tour-step="2"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'Click Duplicate',
                body: 'You can duplicate any app you can view. The duplicate lands in your **Settings > My apps** as a personal app you own, regardless of where the original lives.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-apps"]',
                    '[data-tour-anchor="app-row"][data-tour-value="Jaffle pulse"]',
                    '[data-tour-anchor="app-actions"]',
                ],
            },
            {
                target: '[data-tour-anchor="app-actions"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: "Open the app's actions",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="app-add-to-space"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'Choose Add to space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-anchor="app-actions"]'],
            },
            {
                target: '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'Choose the Shared space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="app-actions"]',
                    '[data-tour-anchor="app-add-to-space"]',
                ],
            },
            {
                target: '[data-tour-anchor="transfer-confirm"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'Confirm the move',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="app-actions"]',
                    '[data-tour-anchor="app-add-to-space"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:DataApp"][data-tour-step="1"]',
                route: '/projects/:projectUuid/apps/:appUuid',
                title: 'See the result',
                body: 'Apps will initially appear in **Settings > My apps.** To share an app with your team, add it to a space or use [Direct access](https://docs.lightdash.com/workspace-admin/direct-access).',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:DashboardComments': {
        scope: 'manage:DashboardComments',
        title: 'Resolve a comment thread',
        sources: [
            'packages/frontend/src/features/comments/components/DashboardTileComments.tsx',
            'packages/frontend/src/features/comments/components/CommentDetail.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:DashboardComments"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Comment on a tile',
                body: 'Every chart, markdown, Loom, and data app tile carries its own comment thread.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-dashboards"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Open All dashboards',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Open Jaffle Shop overview',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                ],
            },
            {
                target: '[data-tour-anchor="tile-comments"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: "Open the tile's comments",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                    '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                ],
            },
            {
                target: '[data-tour-anchor="comment-actions"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: "Open the comment's menu",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                    '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                    '[data-tour-anchor="tile-comments"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:DashboardComments"][data-tour-step="2"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Click Resolve',
                body: "Editors and above can resolve or unresolve a thread and delete anyone's comment.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                    '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                    '[data-tour-anchor="tile-comments"]',
                    '[data-tour-anchor="comment-actions"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:DashboardComments"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'See the result',
                body: 'Resolving hides the whole thread behind the **Show resolved** toggle at the top of the panel.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'create:DashboardComments': {
        scope: 'create:DashboardComments',
        title: 'Comment on a dashboard',
        sources: [
            'packages/frontend/src/features/comments/components/DashboardTileComments.tsx',
            'packages/frontend/src/features/comments/components/CommentForm.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="create:DashboardComments"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Comment on a tile',
                body: 'Every chart, markdown, Loom, and data app tile carries its own comment thread.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-dashboards"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Open All dashboards',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Open Jaffle Shop overview',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                ],
            },
            {
                target: '[data-tour-anchor="tile-comments"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: "Open the tile's comments",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                    '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                ],
            },
            {
                target: '[data-tour-anchor="comment-editor"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Write your comment',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                    '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                    '[data-tour-anchor="tile-comments"]',
                ],
                suggestion:
                    'That January spike looks like the promo. Worth a closer look?',
            },
            {
                target: '[data-tour-scope="create:DashboardComments"][data-tour-step="2"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Click Add comment',
                body: 'Interactive viewers and above can post, reply, and delete their own comments.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                    '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                    '[data-tour-anchor="tile-comments"]',
                    '[data-tour-anchor="comment-editor"]',
                ],
            },
            {
                target: '[data-tour-scope="create:DashboardComments"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'See the result',
                body: "Hover over a tile and click the speech-bubble icon in its header to open the comments panel — on tiles that already have comments, the icon stays visible with a count, and the badge turns red when there are comments you haven't seen.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'view:DashboardComments': {
        scope: 'view:DashboardComments',
        title: 'Read the conversation on a dashboard',
        sources: [
            'packages/frontend/src/features/comments/components/DashboardTileComments.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:DashboardComments"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Comment on a tile',
                body: 'Every chart, markdown, Loom, and data app tile carries its own comment thread.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-dashboards"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Open All dashboards',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'Open Jaffle Shop overview',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                ],
            },
            {
                target: '[data-tour-scope="view:DashboardComments"][data-tour-step="2"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: "Open the tile's comments",
                body: "Hover over a tile and click the speech-bubble icon in its header to open the comments panel — on tiles that already have comments, the icon stays visible with a count, and the badge turns red when there are comments you haven't seen.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-dashboards"]',
                    '[data-tour-anchor="dashboard-row"][data-tour-value="Jaffle Shop overview"]',
                ],
            },
            {
                target: '[data-tour-scope="view:DashboardComments"][data-tour-step="1"]',
                route: '/projects/:projectUuid/dashboards/:dashboardUuid/view',
                title: 'See the result',
                body: 'Everyone who can see the dashboard can read its comments — there are no private comments.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'view:Document': {
        scope: 'view:Document',
        title: 'Read a document',
        sources: [
            'packages/frontend/src/features/documents/DocumentByline.tsx',
            'packages/frontend/src/features/documents/DocumentChartVisualization.tsx',
            'packages/frontend/src/features/documents/presentation/DocumentReportLayout.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:Document"][data-tour-step="1"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Documents',
                body: 'A document is a written report with live charts inside it.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-documents"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Open All documents',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="document-row"][data-tour-value="Monthly orders review"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Open Monthly orders review',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-documents"]',
                ],
            },
            {
                target: '[data-tour-scope="view:Document"][data-tour-look="1"]',
                title: 'See who wrote it and when',
                body: 'The line under the title shows who created the document and when it was last edited.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:Document"][data-tour-step="2"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Jump to a section',
                body: "The rail on the left lists the document's top-level headings; click one to jump to that section.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-documents"]',
                    '[data-tour-anchor="document-row"][data-tour-value="Monthly orders review"]',
                ],
            },
            {
                target: '[data-tour-scope="view:Document"][data-tour-step="1"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'See the result',
                body: 'Charts in a document run against your data every time someone opens it, so the figures stay current.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="document-chart-loading"]',
            },
        ],
    },
    'manage:Document': {
        scope: 'manage:Document',
        title: 'Write a document with a live chart',
        sources: [
            'packages/frontend/src/features/documents/DocumentChartEditorModal.tsx',
            'packages/frontend/src/features/documents/DocumentRenderer.tsx',
            'packages/frontend/src/features/documents/DocumentEditor.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:Document"][data-tour-step="1"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Documents',
                body: 'A document is a written report with live charts inside it.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-document"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Choose Document',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="document-name"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Name the document',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                ],
                suggestion: 'Country orders review',
            },
            {
                target: '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Choose the Shared space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                ],
            },
            {
                target: '[data-tour-anchor="document-create-submit"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Click Create',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                ],
            },
            {
                target: '[data-tour-anchor="document-body"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Write the opening line',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="document-create-submit"]',
                ],
                suggestion: 'Where our orders come from, by country.',
            },
            {
                target: '[data-tour-anchor="document-add-chart"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Click Add chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="document-create-submit"]',
                    '[data-tour-anchor="document-body"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Document"][data-tour-look="1"]',
                title: 'The Add chart dialog is a full Explore view',
                body: 'The **Add chart** dialog is a full [Explore view](https://docs.lightdash.com/explore/explore-view): pick a table, choose metrics and dimensions, configure the chart, and click **Apply to Document**.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="explore-table"][data-tour-value="Country orders"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Open Country orders',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="document-create-submit"]',
                    '[data-tour-anchor="document-body"]',
                    '[data-tour-anchor="document-add-chart"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-metric"][data-tour-value="Order Count"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Find Order Count',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="document-create-submit"]',
                    '[data-tour-anchor="document-body"]',
                    '[data-tour-anchor="document-add-chart"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Country orders"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-dimension"][data-tour-value="Country"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Find Country',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="document-create-submit"]',
                    '[data-tour-anchor="document-body"]',
                    '[data-tour-anchor="document-add-chart"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Country orders"]',
                    '[data-tour-anchor="explore-metric"][data-tour-value="Order Count"]',
                ],
            },
            {
                target: '[data-tour-anchor="run-query"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Run the query',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="document-create-submit"]',
                    '[data-tour-anchor="document-body"]',
                    '[data-tour-anchor="document-add-chart"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Country orders"]',
                    '[data-tour-anchor="explore-metric"][data-tour-value="Order Count"]',
                    '[data-tour-anchor="explore-dimension"][data-tour-value="Country"]',
                ],
            },
            {
                target: '[data-tour-anchor="document-chart-name"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Name the chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="document-create-submit"]',
                    '[data-tour-anchor="document-body"]',
                    '[data-tour-anchor="document-add-chart"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Country orders"]',
                    '[data-tour-anchor="explore-metric"][data-tour-value="Order Count"]',
                    '[data-tour-anchor="explore-dimension"][data-tour-value="Country"]',
                    '[data-tour-anchor="run-query"]',
                ],
                suggestion: 'Orders by country',
            },
            {
                target: '[data-tour-anchor="document-chart-apply"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Click Apply to Document',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="document-create-submit"]',
                    '[data-tour-anchor="document-body"]',
                    '[data-tour-anchor="document-add-chart"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Country orders"]',
                    '[data-tour-anchor="explore-metric"][data-tour-value="Order Count"]',
                    '[data-tour-anchor="explore-dimension"][data-tour-value="Country"]',
                    '[data-tour-anchor="run-query"]',
                    '[data-tour-anchor="document-chart-name"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Document"][data-tour-step="2"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'Save the document',
                body: 'Click the check icon to save, or the cross to cancel.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-document"]',
                    '[data-tour-anchor="document-name"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                    '[data-tour-anchor="document-create-submit"]',
                    '[data-tour-anchor="document-body"]',
                    '[data-tour-anchor="document-add-chart"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Country orders"]',
                    '[data-tour-anchor="explore-metric"][data-tour-value="Order Count"]',
                    '[data-tour-anchor="explore-dimension"][data-tour-value="Country"]',
                    '[data-tour-anchor="run-query"]',
                    '[data-tour-anchor="document-chart-name"]',
                    '[data-tour-anchor="document-chart-apply"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Document"][data-tour-step="1"]',
                route: '/projects/:projectUuid/documents/:documentUuidOrSlug',
                title: 'See the result',
                body: 'Every save creates a new version.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="document-chart-loading"]',
            },
        ],
    },
    'manage:Tags': {
        scope: 'manage:Tags',
        title: 'Put a metric in a category',
        sources: [
            'packages/frontend/src/features/metricsCatalog/components/MetricsCatalogCategoryForm.tsx',
            'packages/frontend/src/features/metricsCatalog/components/MetricCatalogCategoryFormItem.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:Tags"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Browsing the catalog',
                body: '**Categories**: Use categories to streamline your metrics and KPIs.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="metrics"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open Metrics',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="metric-categories"][data-tour-value="Total revenue"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open the categories of Total revenue',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="metrics"]'],
            },
            {
                target: '[data-tour-scope="manage:Tags"][data-tour-step="2"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Choose a category',
                body: '**Users with editor permissions and above** can click on any category cell to edit, rename, change its color, or delete it.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="metrics"]',
                    '[data-tour-anchor="metric-categories"][data-tour-value="Total revenue"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:Tags"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics',
                title: 'See the result',
                body: 'Filter metrics by category and add new ones directly in the UI.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'view:Tags': {
        scope: 'view:Tags',
        title: 'Find metrics by category',
        sources: [
            'packages/frontend/src/features/metricsCatalog/components/MetricsTable.tsx',
            'packages/frontend/src/features/metricsCatalog/components/MetricsTableTopToolbar/CategoriesFilter.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:Tags"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Getting Started',
                body: '**Catalog** — A searchable, filterable table of all your project metrics. Browse metrics by category, owner, or popularity, explore any metric over time in the Metrics Explorer, and curate what your business users see through **.yml** configuration.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="metrics"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open Metrics',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:Tags"][data-tour-step="2"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open the Categories filter',
                body: 'Filter metrics by category and add new ones directly in the UI.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="metrics"]'],
            },
            {
                target: '[data-tour-anchor="category-option"][data-tour-value="Sales"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Choose Sales',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:Tags"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics',
                title: 'See the result',
                body: '**Categories**: Use categories to streamline your metrics and KPIs.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'view:SpotlightTableConfig': {
        scope: 'view:SpotlightTableConfig',
        title: 'View catalog column settings',
        sources: [
            'packages/frontend/src/features/metricsCatalog/components/MetricsTableTopToolbar/index.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:SpotlightTableConfig"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics',
                title: 'View catalog column configuration',
                body: 'The metrics catalog table has a **Manage column visibility** control (the eye icon). Open it to see which columns are shown and the order they appear in.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="metrics"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open Metrics',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:SpotlightTableConfig"][data-tour-step="2"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open Manage column visibility',
                body: 'The metrics catalog table has a **Manage column visibility** control (the eye icon). Open it to see which columns are shown and the order they appear in.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="metrics"]'],
            },
            {
                target: '[data-tour-scope="view:SpotlightTableConfig"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics',
                title: 'See the result',
                body: "You can toggle the other columns or drag their handles to reorder them for your current view. **Discard** returns to the saved project configuration. Reading the project's saved column configuration uses the **View spotlight table configuration** permission.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:SpotlightTableConfig': {
        scope: 'manage:SpotlightTableConfig',
        title: 'Save catalog column settings',
        sources: [
            'packages/frontend/src/features/metricsCatalog/components/MetricsTableTopToolbar/index.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:SpotlightTableConfig"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Save catalog column configuration',
                body: "Users with **Configure spotlight table settings** permission can save the catalog's column visibility and order for everyone in the project.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="metrics"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open Metrics',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="catalog-columns"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Manage column visibility',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="metrics"]'],
            },
            {
                target: '[data-tour-anchor="catalog-column-toggle"][data-tour-value="Description"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Toggle the Description column',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="metrics"]',
                    '[data-tour-anchor="catalog-columns"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:SpotlightTableConfig"][data-tour-step="2"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Save for everyone',
                body: 'Open **Manage column visibility**, adjust the columns, and select **Save for everyone**.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="metrics"]',
                    '[data-tour-anchor="catalog-columns"]',
                    '[data-tour-anchor="catalog-column-toggle"][data-tour-value="Description"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:SpotlightTableConfig"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics',
                title: 'See the result',
                body: "Users with **Configure spotlight table settings** permission can save the catalog's column visibility and order for everyone in the project.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="catalog-save-pending"]',
            },
        ],
    },
    'view:MetricsTree': {
        scope: 'view:MetricsTree',
        title: 'View a saved metrics tree',
        sources: [
            'packages/frontend/src/features/metricsCatalog/components/SavedTrees/SavedTreeCanvas.tsx',
            'packages/frontend/src/features/metricsCatalog/components/MetricsTableTopToolbar/index.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="view:MetricsTree"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics/canvas/:treeSlug',
                title: 'Saved Trees',
                body: '**Saved Trees** are persistent, shareable diagrams of how your metrics relate to each other. Each tree stores its full layout — every node position and every edge — so you can return to the same view next session and share the link with teammates.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="metrics"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open Metrics',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:MetricsTree"][data-tour-step="2"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open Canvas',
                body: 'You build and view Saved Trees on a canvas: switch to the canvas view using the toggle in the top-right corner of the Metrics page.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="metrics"]'],
            },
            {
                target: '[data-tour-anchor="saved-tree"][data-tour-value="Completed orders"]',
                route: '/projects/:projectUuid/metrics',
                title: 'Open Completed orders',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="view:MetricsTree"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics/canvas/:treeSlug',
                title: 'See the result',
                body: "In Saved Trees, driver edges are displayed alongside manually-created edges, giving you a complete picture of both the relationships you've drawn and the ones defined in your data model.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:MetricsTree': {
        scope: 'manage:MetricsTree',
        title: 'Build a saved metrics tree',
        sources: [
            'packages/frontend/src/features/metricsCatalog/components/SavedTrees/SavedTreeCanvas.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:MetricsTree"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics/canvas/:treeSlug',
                title: 'Saved Trees',
                body: '**Saved Trees** are persistent, shareable diagrams of how your metrics relate to each other. Each tree stores its full layout — every node position and every edge — so you can return to the same view next session and share the link with teammates.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="metrics"]',
                route: '/projects/:projectUuid/metrics/canvas',
                title: 'Open Metrics',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="metrics-canvas"]',
                route: '/projects/:projectUuid/metrics/canvas',
                title: 'Open Canvas',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="metrics"]'],
            },
            {
                target: '[data-tour-anchor="tree-new"]',
                route: '/projects/:projectUuid/metrics/canvas',
                title: 'Start a new tree',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="metrics"]',
                    '[data-tour-anchor="metrics-canvas"]',
                ],
            },
            {
                target: '[data-tour-anchor="tree-name"]',
                route: '/projects/:projectUuid/metrics/canvas',
                title: 'Name your tree',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="metrics"]',
                    '[data-tour-anchor="metrics-canvas"]',
                    '[data-tour-anchor="tree-new"]',
                ],
                suggestion: 'Completed orders drivers',
            },
            {
                target: '[data-tour-anchor="metrics-search"]',
                route: '/projects/:projectUuid/metrics/canvas',
                title: 'Find Total completed order amount',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="metrics"]',
                    '[data-tour-anchor="metrics-canvas"]',
                    '[data-tour-anchor="tree-new"]',
                    '[data-tour-anchor="tree-name"]',
                ],
                suggestion: 'Total completed order amount',
            },
            {
                target: '[data-tour-anchor="tree-add-metric"][data-tour-value="Total completed order amount"]',
                route: '/projects/:projectUuid/metrics/canvas',
                title: 'Add Total completed order amount to canvas',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="metrics"]',
                    '[data-tour-anchor="metrics-canvas"]',
                    '[data-tour-anchor="tree-new"]',
                    '[data-tour-anchor="tree-name"]',
                    '[data-tour-anchor="metrics-search"]',
                ],
            },
            {
                target: '[data-tour-anchor="tree-add-drivers"]',
                route: '/projects/:projectUuid/metrics/canvas',
                title: 'Add drivers from YAML',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="metrics"]',
                    '[data-tour-anchor="metrics-canvas"]',
                    '[data-tour-anchor="tree-new"]',
                    '[data-tour-anchor="tree-name"]',
                    '[data-tour-anchor="metrics-search"]',
                    '[data-tour-anchor="tree-add-metric"][data-tour-value="Total completed order amount"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:MetricsTree"][data-tour-step="2"]',
                route: '/projects/:projectUuid/metrics/canvas',
                title: 'Save the tree',
                body: '**Save**: Click **Save**. The button is disabled until you provide a name and add at least one node.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="metrics"]',
                    '[data-tour-anchor="metrics-canvas"]',
                    '[data-tour-anchor="tree-new"]',
                    '[data-tour-anchor="tree-name"]',
                    '[data-tour-anchor="metrics-search"]',
                    '[data-tour-anchor="tree-add-metric"][data-tour-value="Total completed order amount"]',
                    '[data-tour-anchor="tree-add-drivers"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:MetricsTree"][data-tour-step="1"]',
                route: '/projects/:projectUuid/metrics/canvas/:treeSlug',
                title: 'See the result',
                body: 'When you save, the tree name, node positions, edges, and metric references are all persisted.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
    },
    'manage:SqlRunner': {
        scope: 'manage:SqlRunner',
        title: 'Run SQL and save a chart',
        sources: [
            'packages/frontend/src/features/sqlRunner/components/SqlEditor.tsx',
            'packages/frontend/src/features/sqlRunner/components/Header/HeaderView.tsx',
            'packages/frontend/src/features/sqlRunner/components/SaveSqlChartModal.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:SqlRunner"][data-tour-step="1"]',
                route: '/projects/:projectUuid/sql-runner/:slug',
                title: 'SQL runner',
                body: 'Only users with [developer or admin access](https://docs.lightdash.com/workspace-admin/roles) can use the SQL runner.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-sql-runner"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Choose Query using SQL runner',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-scope="manage:SqlRunner"][data-tour-look="1"]',
                title: 'Write a query, then run it',
                body: 'To build a query in the SQL Runner, just write your query in the SQL query builder, then hit **Run query** to see the results.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="sql-runner-editor"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Write your query',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                ],
                suggestion:
                    'SELECT status, COUNT(*) AS orders FROM jaffle.orders GROUP BY 1',
            },
            {
                target: '[data-tour-anchor="sql-runner-run"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Run the query',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-save-chart"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Click Save chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-chart-name"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Name the chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-save-chart"]',
                ],
                suggestion: 'Orders by status',
            },
            {
                target: '[data-tour-anchor="sql-chart-save-next"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Click Next',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-save-chart"]',
                    '[data-tour-anchor="sql-chart-name"]',
                ],
            },
            {
                target: '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Choose the Shared space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-save-chart"]',
                    '[data-tour-anchor="sql-chart-name"]',
                    '[data-tour-anchor="sql-chart-save-next"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:SqlRunner"][data-tour-step="2"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Save the chart',
                body: "Once you've configured your chart, you can save it, add it to a space, and add it to a dashboard by hitting **save chart**.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-save-chart"]',
                    '[data-tour-anchor="sql-chart-name"]',
                    '[data-tour-anchor="sql-chart-save-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:SqlRunner"][data-tour-step="1"]',
                route: '/projects/:projectUuid/sql-runner/:slug',
                title: 'See the result',
                body: "Once you've run your query, you can build a chart by clicking on the **chart** tab in the SQL Runner.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
        covers: ['manage:CustomSql'],
    },
    'view:ContentVerification': {
        scope: 'view:ContentVerification',
        title: 'Verify a chart',
        sources: [
            'packages/frontend/src/components/Explorer/SavedChartsHeader/index.tsx',
            'packages/frontend/src/components/Explorer/SavedChartsHeader/ChartActionsMenu.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:ContentVerification"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Who can verify content',
                body: 'Organization and project admins and developers can verify or unverify charts and dashboards.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Open Orders over time',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
            {
                target: '[data-tour-anchor="chart-actions"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: "Open the chart's actions",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:ContentVerification"][data-tour-step="2"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'Click Verify',
                body: 'Admins and developers can verify content directly from the chart or dashboard, or from the verification panel in project settings.',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                    '[data-tour-anchor="chart-row"][data-tour-value="Orders over time"]',
                    '[data-tour-anchor="chart-actions"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:ContentVerification"][data-tour-step="1"]',
                route: '/projects/:projectUuid/saved/:savedQueryUuid',
                title: 'See the result',
                body: 'Each verified item gets a green checkmark badge that shows who verified it and when. Verification always reflects the current state of the content.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
        coveredBy: 'manage:ContentVerification',
    },
    'view:AiAgentDocument': {
        scope: 'view:AiAgentDocument',
        title: 'Always include a knowledge document in context',
        sources: [
            'packages/frontend/src/ee/features/aiCopilot/components/AiAgentKnowledgeDocumentModal.tsx',
            'packages/frontend/src/ee/features/aiCopilot/components/AiAgentKnowledgeFilesSection.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Knowledge documents',
                body: 'Knowledge documents let you upload longer reference material — glossaries, business policies, supporting context, and internal procedures — that your agent can consult while answering questions.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="ask-ai"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Click Ask AI',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="agent-selector"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Open the agent dropdown',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="ask-ai"]'],
            },
            {
                target: '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Choose Jaffle analyst',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                ],
            },
            {
                target: '[data-tour-anchor="agent-settings"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: "Open the agent's settings",
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                ],
            },
            {
                target: '[data-tour-anchor="knowledge-document"][data-tour-value="Jaffle shop glossary"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Choose Jaffle shop glossary',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                    '[data-tour-anchor="agent-settings"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-look="1"]',
                title: 'Read the summary the agent sees',
                body: "The agent always sees this summary, so it knows the document is available and what's in it. By default, it only reads the full content when a question actually calls for it (**on-demand retrieval**), which keeps conversations fast.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="knowledge-document-open"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Open the document',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                    '[data-tour-anchor="agent-settings"]',
                    '[data-tour-anchor="knowledge-document"][data-tour-value="Jaffle shop glossary"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-look="2"]',
                title: 'Read the document',
                body: "**The agent decides when to open a document.** If your document is never being used, the summary probably isn't specific enough about what it's for.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="modal-close"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Close the dialog',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                    '[data-tour-anchor="agent-settings"]',
                    '[data-tour-anchor="knowledge-document"][data-tour-value="Jaffle shop glossary"]',
                    '[data-tour-anchor="knowledge-document-open"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-step="2"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Turn on Always include in context',
                body: "For documents the agent should apply to every question — not just the ones where the summary happens to match — flip the **Always include in context** toggle in the document's settings panel.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="ask-ai"]',
                    '[data-tour-anchor="agent-selector"]',
                    '[data-tour-anchor="agent-option"][data-tour-value="Jaffle analyst"]',
                    '[data-tour-anchor="agent-settings"]',
                    '[data-tour-anchor="knowledge-document"][data-tour-value="Jaffle shop glossary"]',
                    '[data-tour-anchor="knowledge-document-open"]',
                    '[data-tour-anchor="modal-close"]',
                ],
            },
            {
                target: '[data-tour-anchor="modal-confirm"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'Confirm the change',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-scope="manage:AiAgentDocument"][data-tour-step="1"]',
                route: '/projects/:projectUuid/ai-agents/:agentUuid/edit',
                title: 'See the result',
                body: 'The documents table shows an **Always included** or **On demand** status chip per document so you can see at a glance which documents will be in every prompt.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
        coveredBy: 'manage:AiAgentDocument',
    },
    'manage:CustomSql': {
        scope: 'manage:CustomSql',
        title: 'Run SQL and save a chart',
        sources: [
            'packages/frontend/src/features/sqlRunner/components/SqlEditor.tsx',
            'packages/frontend/src/features/sqlRunner/components/Header/HeaderView.tsx',
            'packages/frontend/src/features/sqlRunner/components/SaveSqlChartModal.tsx',
        ],
        steps: [
            {
                target: '[data-tour-scope="manage:SqlRunner"][data-tour-step="1"]',
                route: '/projects/:projectUuid/sql-runner/:slug',
                title: 'SQL runner',
                body: 'Only users with [developer or admin access](https://docs.lightdash.com/workspace-admin/roles) can use the SQL runner.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-sql-runner"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Choose Query using SQL runner',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-scope="manage:SqlRunner"][data-tour-look="1"]',
                title: 'Write a query, then run it',
                body: 'To build a query in the SQL Runner, just write your query in the SQL query builder, then hit **Run query** to see the results.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="sql-runner-editor"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Write your query',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                ],
                suggestion:
                    'SELECT status, COUNT(*) AS orders FROM jaffle.orders GROUP BY 1',
            },
            {
                target: '[data-tour-anchor="sql-runner-run"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Run the query',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-save-chart"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Click Save chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                ],
            },
            {
                target: '[data-tour-anchor="sql-chart-name"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Name the chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-save-chart"]',
                ],
                suggestion: 'Orders by status',
            },
            {
                target: '[data-tour-anchor="sql-chart-save-next"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Click Next',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-save-chart"]',
                    '[data-tour-anchor="sql-chart-name"]',
                ],
            },
            {
                target: '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Choose the Shared space',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-save-chart"]',
                    '[data-tour-anchor="sql-chart-name"]',
                    '[data-tour-anchor="sql-chart-save-next"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:SqlRunner"][data-tour-step="2"]',
                route: '/projects/:projectUuid/sql-runner',
                title: 'Save the chart',
                body: "Once you've configured your chart, you can save it, add it to a space, and add it to a dashboard by hitting **save chart**.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-sql-runner"]',
                    '[data-tour-anchor="sql-runner-editor"]',
                    '[data-tour-anchor="sql-runner-run"]',
                    '[data-tour-anchor="sql-save-chart"]',
                    '[data-tour-anchor="sql-chart-name"]',
                    '[data-tour-anchor="sql-chart-save-next"]',
                    '[data-tour-anchor="space-option"][data-tour-value="Shared"]',
                ],
            },
            {
                target: '[data-tour-scope="manage:SqlRunner"][data-tour-step="1"]',
                route: '/projects/:projectUuid/sql-runner/:slug',
                title: 'See the result',
                body: "Once you've run your query, you can build a chart by clicking on the **chart** tab in the SQL Runner.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
        ],
        coveredBy: 'manage:SqlRunner',
    },
    'docs:semantic-layer/metrics': {
        scope: 'docs:semantic-layer/metrics',
        title: 'Metrics',
        sources: ['packages/frontend/src/features/learn/sandboxLessons.ts'],
        steps: [
            {
                target: null,
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Metrics',
                body: 'A metric is a value that describes or summarizes features from a collection of data points. For example: count of total number of user IDs, or sum of revenue. In Lightdash, metrics are used to summarize dimensions or, sometimes, other metrics.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="workspace-file"][data-tour-value="models/payments.yml"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Open models/payments.yml',
                body: "To add a metric to Lightdash using the **meta** tag, you define it in your dbt project under the dimension name you're trying to describe/summarize.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="workspace-editor"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Edit the file',
                body: "The **average** metric can be used on any numeric dimension or, [for custom SQL](https://docs.lightdash.com/semantic-layer/metrics#custom-sql-in-aggregate-metrics), any valid SQL expression that gives a numeric table column. Let's add **average_payment_amount**, an **average** metric on the **amount** column: it goes under that column's **metrics**. Add the highlighted lines under **metrics:**, or press Use it, then Check.",
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="models/payments.yml"]',
                ],
                suggestion:
                    '            metrics:\n              average_payment_amount:\n                type: average',
                suggestionContextLines: 1,
                expect: {
                    model: 'payments',
                    column: 'amount',
                    under: 'metrics',
                    field: 'average_payment_amount',
                },
            },
            {
                target: '[data-tour-anchor="terminal-command"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Type the command',
                body: 'You can use the [Lightdash CLI tool](https://docs.lightdash.com/workflow/cli/install) to generate preview projects in Lightdash from your command line.',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="models/payments.yml"]',
                ],
                suggestion: 'lightdash start-preview --name my-preview',
            },
            {
                target: '[data-tour-anchor="terminal-run"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Run the command',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="models/payments.yml"]',
                ],
            },
            {
                target: '[data-learn-terminal-output]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'See the result',
                body: 'Preview projects are commonly used to: test changes in models, metrics and dimensions.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="terminal-running"]',
                retryStep: 2,
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-chart"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Choose Chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="explore-search"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Search for the table',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: ['[data-tour-nav="new"]', '[data-tour-nav="new-chart"]'],
                suggestion: 'Payments',
            },
            {
                target: '[data-tour-anchor="explore-table"][data-tour-value="Payments"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open Payments',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-field-search"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Find Average payment amount',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Payments"]',
                ],
                suggestion: 'Average payment amount',
            },
            {
                target: '[data-tour-anchor="explore-metric"][data-tour-value="Average payment amount"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'The Explore page',
                body: '**Metrics and dimensions** available on the table you selected. **Average payment amount** is the metric you just added.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Payments"]',
                    '[data-tour-anchor="explore-field-search"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-metric"][data-tour-value="Average payment amount"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Add previews to pull requests',
                body: "If you've connected Lightdash to GitHub, you can setup a **github action** and get Lightdash to create new dynamic **preview** projects automatically when a new **pull request** is created, and it will automatically delete the **preview** project when the **pull request** is closed or merged.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Payments"]',
                    '[data-tour-anchor="explore-field-search"]',
                ],
            },
        ],
    },
    'docs:semantic-layer/dimensions': {
        scope: 'docs:semantic-layer/dimensions',
        title: 'Dimensions',
        sources: ['packages/frontend/src/features/learn/sandboxLessons.ts'],
        steps: [
            {
                target: null,
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Dimensions',
                body: 'Dimensions usually match 1:1 with columns in your dbt models (see [additional dimensions](https://docs.lightdash.com/semantic-layer/dimensions#additional-dimensions) for counterexamples).',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="workspace-file"][data-tour-value="models/fm_buildings.yml"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Open models/fm_buildings.yml',
                body: "To customize the dimension, you can do it in your dbt model's YAML file under the **meta** tag.",
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="workspace-editor"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Edit the file',
                body: "For a dimension to appear in Lightdash, you just need to declare it in your dbt model's YAML file. Let's add **number_of_floors** to the **fm_buildings** model's **columns**. Add the highlighted lines under **columns:**, or press Use it, then Check.",
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="models/fm_buildings.yml"]',
                ],
                suggestion:
                    '    columns:\n      - name: number_of_floors\n        description: Storeys above ground',
                suggestionContextLines: 1,
                expect: {
                    model: 'fm_buildings',
                    under: 'columns',
                    field: 'number_of_floors',
                },
            },
            {
                target: '[data-tour-anchor="terminal-command"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Type the command',
                body: 'You can use the [Lightdash CLI tool](https://docs.lightdash.com/workflow/cli/install) to generate preview projects in Lightdash from your command line.',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="models/fm_buildings.yml"]',
                ],
                suggestion: 'lightdash start-preview --name my-preview',
            },
            {
                target: '[data-tour-anchor="terminal-run"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Run the command',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="models/fm_buildings.yml"]',
                ],
            },
            {
                target: '[data-learn-terminal-output]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'See the result',
                body: 'Preview projects are commonly used to: test changes in models, metrics and dimensions.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="terminal-running"]',
                retryStep: 2,
            },
            {
                target: '[data-tour-nav="new"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Click New',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="new-chart"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Choose Chart',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="new"]'],
            },
            {
                target: '[data-tour-anchor="explore-search"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Search for the table',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: ['[data-tour-nav="new"]', '[data-tour-nav="new-chart"]'],
                suggestion: 'Fm buildings',
            },
            {
                target: '[data-tour-anchor="explore-table"][data-tour-value="Fm buildings"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Open Fm buildings',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-field-search"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Find Number of floors',
                body: '',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Fm buildings"]',
                ],
                suggestion: 'Number of floors',
            },
            {
                target: '[data-tour-anchor="explore-dimension"][data-tour-value="Number of floors"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'The Explore page',
                body: '**Metrics and dimensions** available on the table you selected. **Number of floors** is the dimension you just added.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Fm buildings"]',
                    '[data-tour-anchor="explore-field-search"]',
                ],
            },
            {
                target: '[data-tour-anchor="explore-dimension"][data-tour-value="Number of floors"]',
                route: '/projects/:projectUuid/tables/:tableName',
                title: 'Add previews to pull requests',
                body: "If you've connected Lightdash to GitHub, you can setup a **github action** and get Lightdash to create new dynamic **preview** projects automatically when a new **pull request** is created, and it will automatically delete the **preview** project when the **pull request** is closed or merged.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="new"]',
                    '[data-tour-nav="new-chart"]',
                    '[data-tour-anchor="explore-search"]',
                    '[data-tour-anchor="explore-table"][data-tour-value="Fm buildings"]',
                    '[data-tour-anchor="explore-field-search"]',
                ],
            },
        ],
    },
    'view:ContentAsCode': {
        scope: 'view:ContentAsCode',
        title: 'Download a chart as code',
        sources: ['packages/frontend/src/features/learn/codeLessons.ts'],
        steps: [
            {
                target: null,
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Download a chart as code',
                body: 'Treat the downloaded YAML as temporary working files: download, edit by hand or with an AI agent, upload, then discard the local copies instead of committing them.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="terminal-command"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Type the command',
                body: 'From the [Lightdash CLI](https://docs.lightdash.com/workflow/cli/reference), you can use the command **lightdash download** to download all of the charts and dashboards from your Lightdash project as code. If you only want to download specific charts to manage as code, you can use the chart selector in the download command.',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [],
                suggestion:
                    'lightdash download --charts revenue-by-payment-method',
            },
            {
                target: '[data-tour-anchor="terminal-run"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Run the command',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-learn-terminal-output]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'See the result',
                body: 'By default, **lightdash download** will create a new **lightdash** directory in your current working directory and write the content there.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="terminal-running"]',
                retryStep: 1,
            },
            {
                target: '[data-tour-anchor="workspace-file"][data-tour-value="lightdash/charts/revenue-by-payment-method.yml"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Open lightdash/charts/revenue-by-payment-method.yml',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="workspace-editor"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Disposable editing (recommended)',
                body: 'This keeps the Lightdash application as your source of truth while still giving you code-based, agent-assisted editing. **Revenue by payment method** is the chart you just downloaded.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="lightdash/charts/revenue-by-payment-method.yml"]',
                ],
            },
        ],
    },
    'create:ContentAsCode': {
        scope: 'create:ContentAsCode',
        title: 'Change a chart in code and upload it',
        sources: ['packages/frontend/src/features/learn/codeLessons.ts'],
        steps: [
            {
                target: null,
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Change a chart in code and upload it',
                body: "From the [Lightdash CLI](https://docs.lightdash.com/workflow/cli/reference), you can use the command **lightdash upload** to upload any changes you've made to your charts or dashboards as code.",
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="terminal-command"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Type the command',
                body: 'First download the chart, as in **Download a chart as code**.',
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [],
                suggestion:
                    'lightdash download --charts revenue-by-payment-method',
            },
            {
                target: '[data-tour-anchor="terminal-run"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Run the command',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-learn-terminal-output]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'See the result',
                body: 'By default, **lightdash download** will create a new **lightdash** directory in your current working directory and write the content there.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="terminal-running"]',
                retryStep: 1,
            },
            {
                target: '[data-tour-anchor="workspace-file"][data-tour-value="lightdash/charts/revenue-by-payment-method.yml"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Open lightdash/charts/revenue-by-payment-method.yml',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-anchor="workspace-editor"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Edit the file',
                body: "**Edit the YAML files** — make changes to chart and dashboard files in the **lightdash/** directory. Let's rename the chart to **Revenue by payment type**: change its **name** and keep its **slug**, which upload finds the chart by. Edit the **name:** line, or press Use it, then Check.",
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="lightdash/charts/revenue-by-payment-method.yml"]',
                ],
                suggestion: 'name: Revenue by payment type',
                expect: {
                    kind: 'contentAsCode',
                    slug: 'revenue-by-payment-method',
                    name: 'Revenue by payment type',
                },
            },
            {
                target: '[data-tour-anchor="terminal-command"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Type the command',
                body: "**Upload to the preview** — run **lightdash upload --force** to push your changes to the preview environment and verify everything looks right. You must specify the chart using the chart's SLUG.",
                interactive: true,
                advanceOnTargetClick: false,
                advanceOnTargetInput: true,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="lightdash/charts/revenue-by-payment-method.yml"]',
                ],
                suggestion:
                    'lightdash upload --force --charts revenue-by-payment-method',
            },
            {
                target: '[data-tour-anchor="terminal-run"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Run the command',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-anchor="workspace-file"][data-tour-value="lightdash/charts/revenue-by-payment-method.yml"]',
                ],
            },
            {
                target: '[data-learn-terminal-output]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'See the result',
                body: '**lightdash upload** updates any content as code to your project.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [],
                busy: '[data-tour-anchor="terminal-running"]',
                retryStep: 5,
            },
            {
                target: '[data-tour-nav="browse"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Click Browse',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: [],
            },
            {
                target: '[data-tour-nav="all-charts"]',
                route: '/projects/:projectUuid/learn/workspace',
                title: 'Open All saved charts',
                body: '',
                interactive: true,
                advanceOnTargetClick: true,
                advanceOnTargetInput: false,
                via: ['[data-tour-nav="browse"]'],
            },
            {
                target: '[data-tour-anchor="chart-row"][data-tour-value="Revenue by payment type"]',
                route: '/projects/:projectUuid/saved',
                title: 'Disposable editing (recommended)',
                body: 'Treat the downloaded YAML as temporary working files: download, edit by hand or with an AI agent, upload, then discard the local copies instead of committing them. This keeps the Lightdash application as your source of truth while still giving you code-based, agent-assisted editing. **Revenue by payment type** is the chart you just renamed in code.',
                interactive: false,
                advanceOnTargetClick: false,
                advanceOnTargetInput: false,
                via: [
                    '[data-tour-nav="browse"]',
                    '[data-tour-nav="all-charts"]',
                ],
            },
        ],
    },
};
